//@flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, {css} from 'styled-components';
import { rgba } from 'polished';
import { Link } from 'react-router-dom'
import moment from 'moment'

import { LetterLinks } from '../../components'

import { paleGreen } from '../../styles/colors';
import { hoverState, body, padding } from '../../styles/global';
import MetaTags from '../../components/MetaTags/MetaTags';

type Props = {}

type State = {}

class Letters extends Component<Props, State> {
    render() {
        return (
            <Container>
                <LetterLinks/>

                <MetaTags
                    title={'Letters'}
                    description={''}
                />
            </Container>
        )
    }
}

const Container = styled.div`
    background: #F7F7F7;
    min-height: 100vh;
`;

const mapDispatchToProps = dispatch => ({

})

const mapStateToProps = (state, props) => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(Letters);



// WEBPACK FOOTER //
// ./client/modules/Letters/Letters.js